import React, { useState } from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import "./rezervace-akce-new.css";

const ACCESS_KEY = "064c4cce-6523-4670-8d0b-d7c13573254e"; // Web3Forms – form "Akce a firmy", chodí na info@hospudkapodrablinu.cz

const RezervaceAkce: React.FC = () => {
  const [form, setForm] = useState({
    jmeno: "",
    prijmeni: "",
    email: "",
    telefon: "",
    pocet_hostu: "",
    termin1: "",
    typ_akce: "",
    gdpr: false,
    botcheck: "" // honeypot
  });

  const [odeslano, setOdeslano] = useState(false);
  const [chyba, setChyba] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target as HTMLInputElement;
    const checked = (e.target as HTMLInputElement).checked;
    setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setChyba("");

    // jednoduchá validace
    if (!form.jmeno || !form.prijmeni || !form.email || !form.telefon || !form.pocet_hostu || !form.termin1 || !form.gdpr) {
      setChyba("Vyplňte prosím všechna povinná pole a potvrďte souhlas se zpracováním údajů.");
      return;
    }

    // honeypot – pokud je vyplněn, neodesíláme
    if (form.botcheck) return;

    try {
      setLoading(true);

      const payload = {
        access_key: ACCESS_KEY,
        subject: "Rezervace akce – webový formulář",
        from_name: "Hospůdka pod Rablinů – web",
        reply_to: form.email,
        email: form.email, // pro snadnější 'Reply-To' a identifikaci
        jmeno: form.jmeno,
        prijmeni: form.prijmeni,
        telefon: form.telefon,
        pocet_hostu: form.pocet_hostu,
        termin: form.termin1,
        typ_akce: form.typ_akce,
        gdpr: form.gdpr ? "Souhlas udělen" : "Ne",
        botcheck: form.botcheck,
        // Volitelné:
        // redirect: "https://tvoje-domena.cz/dekujeme"
      };

      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      if (data.success) {
        setOdeslano(true);
        setForm({
          jmeno: "",
          prijmeni: "",
          email: "",
          telefon: "",
          pocet_hostu: "",
          termin1: "",
          typ_akce: "",
          gdpr: false,
          botcheck: ""
        });
      } else {
        setChyba(data.message || "Odeslání se nezdařilo. Zkuste to prosím později.");
      }
    } catch {
      setChyba("Odeslání se nezdařilo. Zkuste to prosím později.");
    } finally {
      setLoading(false);
    }
  };

  if (odeslano) {
    return (
      <div className="reservation-page reservation-page--event">
        <Navbar />
        <main className="reservation-shell">
          <div className="form-ok">
            Děkujeme! Vaše nezávazná poptávka byla odeslána. Brzy se vám ozveme.
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="reservation-page reservation-page--event">
      <Navbar />

      <main className="reservation-shell">
        <section className="reservation-hero">
          <div className="reservation-hero__copy">
            <p className="reservation-eyebrow">Nezávazná poptávka</p>
            <h1>Rezervace akce</h1>
            <p className="reservation-lead">
              Napište nám základní parametry akce a požadovaný termín. Připravíme
              pro vás návrh dalšího postupu i dostupnosti.
            </p>
          </div>
        </section>

        <div className="reservation-form-stage">
          <div className="kontakt-form-outer">
            <form className="kontakt-form" onSubmit={handleSubmit} autoComplete="off">
              <div className="field-group field-group--half">
                <label htmlFor="akce-jmeno">Jméno</label>
                <input id="akce-jmeno" name="jmeno" type="text" placeholder="Např. Jan" value={form.jmeno} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="akce-prijmeni">Příjmení</label>
                <input id="akce-prijmeni" name="prijmeni" type="text" placeholder="Např. Novák" value={form.prijmeni} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="akce-email">E-mail</label>
                <input id="akce-email" name="email" type="email" placeholder="vas@email.cz" value={form.email} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="akce-telefon">Telefon</label>
                <input id="akce-telefon" name="telefon" type="tel" placeholder="+420 123 456 789" value={form.telefon} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="akce-pocet-hostu">Počet hostů</label>
                <input id="akce-pocet-hostu" name="pocet_hostu" type="number" placeholder="Např. 60" value={form.pocet_hostu} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--half">
                <label htmlFor="akce-termin1">Datum akce</label>
                <input id="akce-termin1" name="termin1" type="date" value={form.termin1} onChange={handleChange} required />
              </div>

              <div className="field-group field-group--full">
                <label htmlFor="akce-typ">Typ akce nebo poznámky</label>
                <textarea id="akce-typ" name="typ_akce" placeholder="Např. svatební hostina, firemní večírek, oslava narozenin nebo speciální požadavky." value={form.typ_akce} onChange={handleChange} rows={4} />
              </div>

              <input type="text" name="botcheck" value={form.botcheck} onChange={handleChange} tabIndex={-1} autoComplete="off" style={{ display: "none" }} />

              <label className="form-gdpr field-group--full">
                <input type="checkbox" name="gdpr" checked={form.gdpr} onChange={handleChange} required />
                <span>Souhlasím se zpracováním osobních údajů a odesláním nezávazné poptávky.</span>
              </label>

              {chyba && <div className="form-error field-group--full">{chyba}</div>}

              <div className="form-actions field-group--full">
                <button type="submit" disabled={loading}>
                  {loading ? "Odesílám…" : "Odeslat nezávaznou poptávku"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>

  );
};

export default RezervaceAkce;
